import gql from 'graphql-tag';

export default gql`
  mutation addBaseUom($input: AddBaseUomInput!) {
    addBaseUom(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
